import React from 'react';

import Icon from '../Icon/Icon';

const VibrateEnabledRestrictedIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M45.054 23.12a14.982 14.982 0 0 1-.401 15.662M50.532 20.02a21.302 21.302 0 0 1-.55 22.238M18.946 23.12a14.982 14.982 0 0 0 .401 15.662M13.468 20.02a21.302 21.302 0 0 0 .55 22.238'
                stroke='#232029'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M33.333 24 28 32h8l-5.333 8'
                stroke='#34303D'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default VibrateEnabledRestrictedIcon;
